<template>
  <div id="Schedule">
    <div id="Schedule-selector"></div>
    <b-container fluid class="scheduleMain">
      <b-row>
        <b-col>
          <h2>2025 Schedule</h2>
          <div class="line"></div>
        </b-col>
      </b-row>
      <div class="legend">
        <div class="legend-icon home"></div>
        <!-- <strong>Exhibition Games</strong> -->
        <div class="legend-icon non-premier-legend"></div>
        <strong>Home Games</strong>
      </div>
      <div class="scheduleWrapper">
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>March/April</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day no-game">
                <div class="day-number">23</div>
                <p></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">24</div>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">25</div>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">26</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  BOS
                  <span>3:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  BOS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">29</div>
                <p>
                  BOS
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">30</div>
                <p>
                  BOS
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">31</div>
                <p>CIN <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>CIN <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>CIN <span></span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">3</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  TB
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  TB
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  TB
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">7</div>
                <p>CHC</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">8</div>
                <p>CHC</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">9</div>
                <p>CHC</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">10</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>SEA</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>SEA</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>SEA</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">15</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">16</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">17</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  LAD
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  LAD
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  LAD
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">21</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">22</div>
                <p>ATH</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">23</div>
                <p>ATH</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>ATH</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>SF</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>SF</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">27</div>
                <p>SF</p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">29</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">30</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>May</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">1</div>
                <p>
                  ATH
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">2</div>
                <p>
                  SEA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">3</div>
                <p>
                  SEA
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  SEA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">5</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">6</div>
                <p>BOS</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">7</div>
                <!-- <p class="double">OAK <span>DOUBLEHEADER</span></p> -->
                <p>BOS</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">8</div>
                <p>BOS</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">9</div>
                <p>DET</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>DET</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>DET</p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">12</div>
                <p>
                  COL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">13</div>
                <p>
                  COL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">14</div>
                <p>
                  COL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">15</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">16</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">17</div>
                <p>
                  HOU
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  HOU
                  <span>12:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">19</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">20</div>
                <p>NYY</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">21</div>
                <p>NYY</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">22</div>
                <p>NYY</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">23</div>
                <p>CWS</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>CWS</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>CWS</p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  TOR
                  <span>3:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  TOR
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  TOR
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">29</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">30</div>
                <p>
                  STL
                  <span>7:05</span>
                </p>
              </span>
              <div class="calendar-day home">
                <div class="day-number">31</div>
                <p>STL <span>3:05</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>June</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">1</div>
                <p>STL <span>12:05</span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">2</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">3</div>
                <p>TB</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">4</div>
                <p>TB</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">5</div>
                <p>TB</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">6</div>
                <p>WSH</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">7</div>
                <p>WSH</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">8</div>
                <p>WSH</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">9</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>MIN</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>MIN</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>MIN</p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">13</div>
                <p>
                  CWS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">14</div>
                <p>
                  CWS
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">15</div>
                <p>
                  CWS
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">16</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">17</div>
                <p>
                  KC
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  KC
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  KC
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">20</div>
                <p>PIT</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">21</div>
                <p>PIT</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">22</div>
                <p>PIT</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">23</div>
                <p>BAL</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>BAL</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>BAL</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">26</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  SEA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  SEA
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <div class="calendar-day home">
                <div class="day-number">29</div>
                <p>
                  SEA
                  <span>1:35</span>
                </p>
              </div>
              <span class="calendar-day home">
                <div class="day-number">30</div>
                <p>
                  BAL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day calendar-day-np"></span>
              <span class="calendar-day calendar-day-np"></span>
              <span class="calendar-day calendar-day-np"></span>
              <span class="calendar-day calendar-day-np"></span>
              <span class="calendar-day calendar-day-np"></span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>July</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day home">
                <div class="day-number">1</div>
                <p>
                  BAL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">2</div>
                <p>
                  BAL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">3</div>
              </span>
              <span class="calendar-day">
                <div class="day-number">4</div>
                <p>SD</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">5</div>
                <p>SD</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">6</div>
                <p>SD</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">7</div>
                <p>LAA <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">8</div>
                <p>LAA <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">9</div>
                <p>LAA <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>LAA <span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>HOU<span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>HOU<span></span></p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>HOU<span>7:05</span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day no-game all-star">
                <div class="day-number">15</div>
                <p>ALL-STAR GAME <span></span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">16</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">17</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  DET
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  DET
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  DET
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">24</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  ATL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  ATL
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  ATL
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">28</div>
                <p>LAA</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>LAA</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">30</div>
                <p>LAA</p>
              </span>
              <div class="calendar-day">
                <div class="day-number">31</div>
                <p>SEA</p>
              </div>
              <div class="calendar-day-np"></div>
              <div class="calendar-day-np"></div>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>August</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>SEA</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>SEA</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">3</div>
                <p>SEA</p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  NYY
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  NYY
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  NYY
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">7</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  PHI
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">9</div>
                <p>
                  PHI
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">10</div>
                <p>
                  PHI
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">11</div>
                <p>
                  AZ
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">12</div>
                <p>
                  AZ
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">13</div>
                <p>
                  AZ
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">15</div>
                <p>TOR</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">16</div>
                <p>TOR</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">17</div>
                <p>TOR</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">18</div>
                <p>KC</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">19</div>
                <p>KC</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">20</div>
                <p>KC</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">21</div>
                <p>KC</p>
                <p><span></span></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  CLE
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  CLE
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">24</div>
                <p>
                  CLE
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">28</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>ATH</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">30</div>
                <p>ATH</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">31</div>
                <p>ATH</p>
              </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>September</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>AZ</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>AZ</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">3</div>
                <p>AZ</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">4</div>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  HOU
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">7</div>
                <p>
                  HOU
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  MIL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">9</div>
                <p>
                  MIL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">10</div>
                <p>
                  MIL
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">11</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>NYM</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>NYM</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">14</div>
                <p>NYM</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">15</div>
                <p>HOU</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">16</div>
                <p>HOU</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">17</div>
                <p>HOU</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">18</div>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  MIA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  MIA
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  MIA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">22</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  MIN
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">24</div>
                <p>
                  MIN
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  MIN
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>CLE</p>
              </span>
              <span class="calendar-day">
                <div class="day-number">27</div>
                <p>CLE</p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">28</div>
                <p>CLE</p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">29</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">30</div>
                <!-- <p>OAK <span></span></p> -->
              </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <b-container fluid class="small-text-container">
      <p class="small-text">Schedule subject to change.</p>
    </b-container>
    <!-- <b-container id="learn-more-container">
      <div id="learn-more-text">
        <p>
          Learn more about special 2022 Theme & Community Nights at Globe Life
          Field.
        </p>
      </div>
      <a
        href="https://www.mlb.com/rangers/tickets/groups/theme-community-nights/theme-nights"
      >
        <div id="theme-nights-box" class="learn-more-rects">
          <img
            src="@/assets/images/img_theme-nights.jpg"
            alt="Theme Nights"
          /></div
      ></a>
      <a
        href="https://www.mlb.com/rangers/tickets/groups/theme-community-nights/community-nights"
      >
        <div id="community-nights-box" class="learn-more-rects">
          <img
            src="@/assets/images/img_community-nights.jpg"
            alt="Community Nights"
          /></div
      ></a>
    </b-container> -->
  </div>
</template>

<script>
export default {
  name: "Schedule",
};
</script>

<style lang="scss" scoped>
#Schedule {
  padding: 50px 0;
  margin: 0 auto;
  background: linear-gradient(134.22deg, #fbfbfb 0%, #eaeaea 100%);
  .scheduleMain {
    max-width: $xl;
    padding: 0 7%;
    h2 {
      width: 143px;
      text-align: left;
      color: $dark-blue;
      font-size: 40px;
      line-height: 32px;
      text-transform: uppercase;
      font-family: "BertholdCondensed";
      font-weight: 700;
    }
    .scheduleWrapper {
      display: flex;
      flex-wrap: wrap;
      min-width: 100%;
      width: calc(100% + 20px);
      justify-content: center;
      margin-left: -10px;
      margin-top: 30px;
      background-color: #fff;
      padding: 1.5%;
      .calendar {
        width: 100%;
        height: auto;
        overflow: hidden;
        background: #fff;
        color: $calendar-blue;
      }
      .calendar .calendar-month {
        h3 {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 900;
          text-transform: uppercase;
        }
        h3 span {
          background: #fff;
          margin: 0 2px;
        }
        // h3:after {
        //   background: $gold;
        //   height: 2px;
        //   flex: 1;
        //   content: "";
        // }
        h3.right:before {
          background: none;
        }
      }
      .calendar .calendar-day-head {
        width: calc(100% / 7);
        display: block;
        float: left;
        text-align: center;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "BertholdCondensed";
        font-weight: 700;
      }
      .calendar .calendar-day-np,
      .calendar .calendar-day {
        position: relative;
        width: calc(100% / 7.4);
        display: block;
        float: left;
        height: 50px;
        background: white;
        color: #000000;
        border: 1px solid $calendar-blue;
        border-radius: 5px;
        margin: 1px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
        .double {
          span {
            font-size: 6px;
          }
        }
        &.exhibition {
          background: $calendar-blue;
          border-color: $calendar-blue;
          color: #fff;
          .day-number {
            color: #fff;
          }
          p {
            color: #fff;
            span {
              color: #fff;
            }
            .double {
              span {
                font-size: 6px;
              }
            }
          }
        }
        &.non-premier,
        &.home {
          background: $calendar-red;
          border-color: $calendar-red;
          color: #fff;
          .day-number {
            color: #fff;
          }
          p {
            color: #fff;
            span {
              color: #fff;
            }
            .double {
              span {
                font-size: 6px;
              }
            }
          }
        }
        &.premier {
          background: $gold;
          border-color: $gold;
          color: #fff;
          .day-number {
            color: #fff;
          }
          p {
            color: #fff;
            span {
              color: #fff;
            }
            .double {
              span {
                font-size: 6px;
              }
            }
          }
        }
        &.no-game {
          background: $grey;
          border-color: $grey;
        }
        &.all-star {
          p {
            font-size: 11px;
            .double {
              font-size: 6px;
            }
          }
        }
      }
      .calendar .calendar-row {
        position: relative;
        overflow: hidden;

        .calendar-day-np {
          border: none;
          background-color: none;
        }

        #allstarText {
          p {
            font-size: 10px;
          }
        }
      }
      .calendar .calendar-day.small {
        height: 25px;
        &.abs-left {
          position: absolute;
          left: 0;
          top: 25px;
        }
        &.abs-left2 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
        }
        &.abs-left3 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc(100% / 7);
        }
        &.abs-left4 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 14.2857143%);
        }
        &.abs-left5 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 28.5714286%);
        }
        p {
          padding: 5px 0;
          font-size: 12px;
          line-height: 12px;
          margin: 0;
          margin-left: 5px;
          span {
            display: block;
            margin-top: -4px;
            font-size: 8px;
          }
        }
      }
      .calendar .calendar-day .day-number {
        color: $calendar-blue;
        position: absolute;
        font-size: 9px;
        top: 2px;
        left: 2px;
        font-family: "BertholdCondensed";
        font-weight: 700;
      }
      .calendar .calendar-day p {
        margin: 0;
        padding: 20px 0;
        font-size: 16px;
        display: block;
        text-align: center;
        line-height: 1;
        color: $calendar-blue;
        font-family: "BertholdCondensed";
        font-weight: 700;
        span {
          display: block;
          font-size: 8px;
          margin-top: 0px;
          color: #00285e;
        }
      }
      .calendar .calendar-day.active {
        background: #002d62;
        .day-number,
        p {
          color: #fff;
          span {
            color: #fff;
          }
        }
      }
      .calendar .calendar-day.active .day-number,
      .calendar .calendar-day.active p {
        color: white;
      }
      .schedule-item {
        width: calc(33.33% - 21px);
        margin: 10px;
        @media only screen and (max-width: $lg) {
          width: calc(50% - 21px);
        }
        @media only screen and (max-width: $md) {
          width: calc(100% - 21px);
        }
      }
    }
    .legend {
      font-family: "BertholdCondensed";
      font-weight: 700;
      font-size: 15px;
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      text-transform: uppercase;
      @media only screen and (max-width: $sm) {
        flex-wrap: wrap;
        justify-content: left;
        gap: 2px;
      }
      .legend-icon {
        height: 14px;
        transform: rotate(45deg);
        width: 14px;
        margin: 4px 7px 0 0;
        @media only screen and (max-width: $sm) {
        }
      }
      // .home {
      //   background-color: $calendar-blue;
      // }
      .non-premier-legend {
        background-color: $calendar-red;
      }
      .premier-legend {
        background-color: $gold;
      }
      strong {
        font-size: 15px;
        color: #000;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 20px;
        font-weight: 800;
        @media only screen and (max-width: $sm) {
          width: 90%;
          text-align: left;
          margin: 0;
        }
      }
      span {
        font-size: 16px;
        color: #000;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
  }
  .small-text-container {
    max-width: $xl;
    padding: 0 7%;
    margin: 16px auto;
    .small-text {
      text-align: right;
      margin: 0;
      font-size: 10px;
      color: #6b6b6b;
    }
  }
  #learn-more-container {
    display: flex;
    @media only screen and (max-width: $md) {
      flex-direction: column;
    }
    #learn-more-text {
      flex-basis: 33%;
      margin: 0 25px 0 0;
      @media only screen and (max-width: $md) {
        margin: 0 15%;
      }
      p {
        color: $rangers-blue;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 20px;
        text-align: right;
        @media only screen and (max-width: $md) {
          text-align: center;
        }
      }
    }
    .learn-more-rects {
      flex-basis: 33%;
      height: 85px;
      width: 350px;
      border-radius: 5px;
      background-color: #ffffff;
      box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.1);
      img {
        max-width: 90%;
        max-height: 90%;
      }
    }
    #theme-nights-box {
      margin: 0 8px 0 0;
      @media only screen and (max-width: $md) {
        margin: 0 auto 5px;
      }
    }
    #community-nights-box {
      margin: 0 50px 0 0;
      @media only screen and (max-width: $md) {
        margin: 0 auto;
      }
    }
  }
}
</style>
